import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

import type { Poll } from './components/poll-context/pollTypes';

export const POLL_TYPE = 'wix-draft-plugin-poll';

export type PollServiceApi = {
  fetchPoll: (pollId: string) => Promise<Poll>;
  createPoll: (poll: Poll) => Promise<Poll>;
  updatePoll: (poll: Poll) => Promise<Poll>;
  vote: (pollId: string, optionId: string) => Promise<Poll>;
  unvote: (pollId: string, optionId: string) => Promise<Poll>;

  getVoters: (pollId: string, optionId: string, params: any) => Promise<any>;
};

export interface PollPluginEditorConfig extends EditorPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  pollServiceApi?: PollServiceApi;
  showVoteRoleSetting?: boolean;
}
export interface PollPluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  onBeforeVote?: ({ voteRole }: { voteRole?: string }) => Promise<void>;
  getSiteMembers?: (ids: string[]) => Promise<PollsMember[]>;
}

export type PollsMember = {
  siteMemberId?: string;
  imageUrl?: string;
  name?: {
    nick?: string;
  };
};
